module.exports = "<svg viewBox=\"0 0 22 25\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>flash</title><desc>Created with Sketch.</desc><defs></defs><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><polygon id=\"flash\" fill=\"#000000\" points=\"8.727 13.773 8.578 13.773 2.25 25 22.102 8.972 11.852 8.972 20.055 0.199 9.129 0.199 0 12.972 8.727 12.972 8.727 13.113 8.949 13.113 8.727 13.512\"></polygon></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/icons/lightning.svg
// module id = 172
// module chunks = 0